module.exports = __webpack_public_path__ + "dfb692bf6e73757f5ae8e73863cf87b1.jpg";